import { tenantManagementActions } from "../../constants/actionTypes";

const INITIAL_STATE = {
  tenantList: {},
  tenantActionData: {},
  createTenant: {},
  editTenant: {},
  tenantViewdata: "",
  tenantLogoData: {},
  tenantLogoDataError: {},
  accountManagerList: [],
  csmAdminsList: [],
  accountManagerError: {},
  csmAdminsError: {},
  machineCatalogList: [],
  machineCatalogError: {},
  tenantCreationData: "",
  tenantDetailsByID: {},
  tenantDetailsErrorByID: {},
  pricingSummeryData: {},
  pricingSummeryError: {},
  setQuotaCreate: "",
  setQuotaGet: "",
  setQuotaUpdate: "",
  notificationSettingsCreate: "",
  notificationSettingsGet: "",
  notificationSettingsUpdate: "",
  createPricingProfile: "",
  editPricingProfile: "",
  tenantSummaryData: "",
  tenantSummaryError: "",
  tenantDeleteData: "",
  extAndExpCreateData: {},
  extAndExpCreateError: "",
  extAndExpEditData: {},
  extAndExpEditError: "",
  extAndExpError: "",
  extAndExpFetchData: {},
  htmlTemplateData: "",
  htmlTemplateListData: "",
  tenantSettingsData: "",
  tenantSettingsError: "",
  tenantListLoading: false,
  tenantListPaginated: [{ id: "all", key: "all", label: "All", tenant_name: "All" }],
};

const tenantManagement = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case tenantManagementActions.tenantCreateSuccess:
      return {
        ...state,
        createTenant: {
          ...action.payload,
        },
      };

    case tenantManagementActions.tenantEditSuccess:
      return {
        ...state,
        editTenant: {
          ...action.payload,
        },
      };

    case tenantManagementActions.SET_TENANT_LIST_LOADING:
      return {
        ...state,
        tenantListLoading: action?.payload,
      };

    case tenantManagementActions.RESET_TENANT_LIST_PAGINATION:
      return {
        ...state,
        tenantListPaginated: {},
      };

    case tenantManagementActions.SET_TENANT_LIST_PAGINATION:
      const old_res = state?.tenantListPaginated?.results || [];
      const new_res = action?.payload?.results || [];
      return {
        ...state,
        tenantListPaginated: {
          ...state?.tenantListPaginated,
          results: [...old_res, ...new_res],
        },
      };

    case tenantManagementActions.tenantListSetData:
    case tenantManagementActions.tenantPlayPauseData:
      return {
        ...state,
        tenantList: {
          ...action?.payload,
        },
      };

    case tenantManagementActions.tenantDeleteData:
      const newTenantList = state.tenantList.results.filter((tenant) => {
        if (tenant.id !== action.payload.id) {
          return tenant;
        } else {
          return;
        }
      });

      return {
        ...state,
        tenantList: {
          ...state.tenantList,
          results: [...newTenantList],
        },
      };

    case tenantManagementActions.tenantActionSuccess:
      return {
        ...state,
        tenantActionData: action.data,
        tenantLogoData: {},
      };

    case tenantManagementActions.tenantDeleteSuccess:
      return {
        ...state,
        tenantDeleteData: action.payload,
      };

    case tenantManagementActions.tenantViewSuccess:
      return {
        ...state,
        tenantViewdata: {
          ...action.payload?.data,
        },
      };
    case tenantManagementActions.UPLOAD_TENANT_LOGO_SUCCESS:
      return {
        ...state,
        tenantLogoData: action?.payload,
      };
    case tenantManagementActions.UPLOAD_TENANT_LOGO_ERROR:
      return {
        ...state,
        tenantLogoDataError: action?.payload,
      };
    case tenantManagementActions.SET_ACCOUNT_MANAGER_LIST:
      return {
        ...state,
        accountManagerList: action?.payload,
      };
    case tenantManagementActions.SET_CSM_ADMIN_LIST:
      return {
        ...state,
        csmAdminsList: action?.payload,
      };
    case tenantManagementActions.ACCOUNT_MANAGER_LIST_ERROR:
      return {
        ...state,
        accountManagerError: action?.payload,
      };
    case tenantManagementActions.CSM_ADMIN_LIST_ERROR:
      return {
        ...state,
        csmAdminsError: action?.payload,
      };
    case tenantManagementActions.SET_MACHINE_CATALOG_LIST:
      return {
        ...state,
        machineCatalogList: action?.payload,
      };
    case tenantManagementActions.MACHINE_CATALOG_LIST_ERROR:
      return {
        ...state,
        machineCatalogError: action?.payload,
      };
    case tenantManagementActions.TENANT_CREATION_SUCCESS:
      return {
        ...state,
        tenantCreationData: action?.payload,
        tenantLogoData: "",
      };
    case tenantManagementActions.SET_TENANT_DETAILS_BY_ID:
      return {
        ...state,
        tenantDetailsByID: action?.payload,
      };
    case tenantManagementActions.SET_TENANT_DETAILS_ERROR_BY_ID:
      return {
        ...state,
        tenantDetailsErrorByID: action?.payload,
      };

    case tenantManagementActions.SUCCESS_PRICING_PROFILE:
      return {
        ...state,
        pricingSummeryData: action?.payload?.data ? action?.payload?.data : {},
      };

    case tenantManagementActions.ERROR_PRICING_PROFILE:
      return {
        ...state,
        pricingSummeryError: action?.payload,
      };

    case tenantManagementActions.SET_QUOTA_FORM_SUCCESS:
      return {
        ...state,
        setQuotaCreate: action?.data,
      };
    case tenantManagementActions.SET_QUOTA_FORM_GET_SUCCESS:
      return {
        ...state,
        setQuotaGet: action?.data,
      };
    case tenantManagementActions.SET_QUOTA_FORM_UPDATE_SUCCESS:
      return {
        ...state,
        setQuotaUpdate: action?.data,
      };
    case tenantManagementActions.NOTIFICATION_SETTINGS_FORM_SUCCESS:
      return {
        ...state,
        notificationSettingsCreate: action?.data,
      };
    case tenantManagementActions.NOTIFICATION_SETTINGS_GET_SUCCESS:
      return {
        ...state,
        notificationSettingsGet: action?.data,
      };
    case tenantManagementActions.NOTIFICATION_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        notificationSettingsUpdate: action?.data,
      };
    case tenantManagementActions.PRICING_PROFILE_CREATE_SUCCESS:
      return {
        ...state,
        createPricingProfile: {
          ...action?.payload,
        },
      };
    case tenantManagementActions.PRICING_PROFILE_CREATE_ERROR:
      return {
        ...state,
        createPricingProfile: { ...action?.payload },
      };
    case tenantManagementActions.PRICING_PROFILE_EDIT_SUCCESS:
      return {
        ...state,
        editPricingProfile: {
          ...action?.payload,
        },
      };
    case tenantManagementActions.PRICING_PROFILE_EDIT_ERROR:
      return {
        ...state,
        editPricingProfile: { ...action?.payload },
      };
    case tenantManagementActions.SET_TENANT_FORM_SUMMARY_ERROR:
      return {
        ...state,
        tenantSummaryError: action?.payload,
      };
    case tenantManagementActions.SET_TENANT_FORM_SUMMARY:
      return {
        ...state,
        tenantSummaryData: action?.payload,
      };
    case tenantManagementActions.SET_EXTENSION_FORM_CREATE:
      return {
        ...state,
        extAndExpCreateData: action?.payload,
      };
    case tenantManagementActions.SET_EXTENSION_FORM_CREATE_ERROR:
      return {
        ...state,
        extAndExpCreateError: action?.payload,
      };
    case tenantManagementActions.SET_EXTENSION_FORM_UPDATE:
      return {
        ...state,
        extAndExpEditData: action?.payload,
      };
    case tenantManagementActions.SET_EXTENSION_FORM_UPDATE_ERROR:
      return {
        ...state,
        extAndExpEditError: action?.payload,
      };
    case tenantManagementActions.SET_EXTENSION_FORM_DATA:
      return {
        ...state,
        extAndExpFetchData: action?.payload,
      };

    case tenantManagementActions.SET_EXTENSION_FORM_ERROR:
      return {
        ...state,
        extAndExpError: action?.payload,
      };
    case tenantManagementActions.UPLOAD_HTML_TEMPLATE_SUCCESS:
    case tenantManagementActions.UPLOAD_HTML_TEMPLATE_ERROR:
      return {
        ...state,
        htmlTemplateData: action?.payload,
      };
    case tenantManagementActions.HTML_TEMPLATE_FETCH_LIST_SUCCESS:
      return {
        ...state,
        htmlTemplateListData: {
          ...action?.payload?.data,
        },
      };
    case tenantManagementActions.HTML_TEMPLATE_FETCH_LIST_ERROR:
      return {
        ...state,
        htmlTemplateListData: { ...action?.payload?.response },
      };
    case tenantManagementActions.SET_TENANT_SETTINGS_DATA:
      return {
        ...state,
        tenantSettingsData: action?.payload?.data,
      };
    case tenantManagementActions.SET_TENANT_SETTINGS_ERROR:
      return {
        ...state,
        tenantSettingsError: action?.payload,
      };
    default:
      return state;
  }
};

export default tenantManagement;
